import React from "react"

import FormatMessage from "@irati/utils/lang"
import {Label} from "@irati/ui/src/Typography"
import {TD_STYLE} from "@irati/ui/src/Table"
import Icon, {IconTypes} from "@irati/ui/src/Icon"

import {ExpandedCell, RightAlignedHeader} from "./styled"

interface CellProps {
  index: number,
  value: string
}

const columns = (formatMessage: FormatMessage, expandedIndex?: number) => [
  {
    Header: () => <Label paddingLeft={4}>{formatMessage({id: "admin.components.teamEngagement.teamBreakdown.column.teams"})}</Label>,
    id: "name",
    accessor: "teamName",
    width: "100%",
    style: {...TD_STYLE, padding: 0, border: "none"},
    headerStyle: {border: "none", width: 200},
    expander: true,
    Expander: (props: CellProps) => {
      const isExpanded = expandedIndex === props.index
      return <ExpandedCell small={!isExpanded} isExpanded={isExpanded}>
        {props.original.teamName.replace("platform.billingUnit.", "")}
        <Icon icon={isExpanded ? IconTypes.chevronUp : IconTypes.chevronDown} marginLeft={1} />
      </ExpandedCell>
    }
  },
  {
    Header: <RightAlignedHeader>
      <Label>
        {formatMessage({id: "admin.components.teamEngagement.teamBreakdown.column.active"})}
      </Label>
    </RightAlignedHeader>,
    accessor: "engaged",
    width: 250,
    style: {...TD_STYLE, padding: 0, border: "none", "text-align": "right"},
    headerStyle: {border: "none"},
    Cell: (props: CellProps) => {
      const isExpanded = expandedIndex === props.index
      return <ExpandedCell small={!isExpanded} isExpanded={isExpanded}>{props.value}%</ExpandedCell>
    }
  },
  {
    Header: <RightAlignedHeader>
      <Label>
        {formatMessage({id: "admin.components.teamEngagement.teamBreakdown.column.usage"})}
      </Label>
    </RightAlignedHeader>,
    accessor: "overall",
    width: 250,
    style: {...TD_STYLE, padding: 0, border: "none", "text-align": "right"},
    headerStyle: {border: "none"},
    Cell: (props: CellProps) => {
      const isExpanded = expandedIndex === props.index
      return <ExpandedCell small={!isExpanded} isExpanded={isExpanded}>{props.value}%</ExpandedCell>
    }
  }
]
export default columns
